import { useState } from 'react';
import { useApi, useRouteRef } from '@backstage/core-plugin-api';
import { useNavigate } from 'react-router-dom';
import { spassuCodeApiRef } from '../../api';
import { activityConnectRouteRef } from '../../routes';
import { normalizeRouteRefPath } from '../../utils/routes';
import type { CreateActivityDialogProps } from './CreateActivityDialog';
import {
  buildCreationInput,
  validateCreationDraft,
  CreationDraft,
} from './creationInput';
import type { useCreationFeedback } from './useCreationFeedback';

export function useCreationSubmission(
  props: CreateActivityDialogProps,
  draft: CreationDraft,
  feedback: ReturnType<typeof useCreationFeedback>,
  reset: () => void,
) {
  const api = useApi(spassuCodeApiRef);
  const navigate = useNavigate();
  const connectRoute = useRouteRef(activityConnectRouteRef);
  const [submitting, setSubmitting] = useState(false);
  const submit = async () => {
    const errors = validateCreationDraft(draft);
    feedback.setFieldErrors(errors);
    if (Object.keys(errors).length > 0) return;
    setSubmitting(true);
    feedback.setError(undefined);
    try {
      const activity = await (
        props.gateway?.create ?? api.createActivity.bind(api)
      )(buildCreationInput(draft));
      props.onCreated?.();
      reset();
      props.onClose();
      if (props.journey) props.journey.onCreated(activity);
      else
        navigate(
          normalizeRouteRefPath(connectRoute({ activityId: activity.id })),
        );
    } catch (e) {
      feedback.setError(
        `Erro ao criar atividade: ${
          e instanceof Error ? e.message : String(e)
        }`,
      );
    } finally {
      setSubmitting(false);
    }
  };
  const close = () => {
    if (submitting) return;
    reset();
    props.onClose();
  };
  return { submitting, submit, close };
}
export type CreationSubmission = ReturnType<typeof useCreationSubmission>;
